import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import useMediaQuery from "@mui/material/useMediaQuery";

import SearchInput from "./SearchInput";
import AdvancedSearch from "../AdvancedSearch/index";
import AssetItemSkeleton from "./aseet-list/AssetItemSkeleton";
import useAuth from "../../hooks/useAuth";
import SearchScanner from "./SearchScanner";
import useQueryParams from "../../hooks/useQueryParams";
import ActiveFilterChips from "../ActiveFilterChips";

const styles = {
  card: {
    overflow: "auto",
  },
  searchContainer: {
    position: "relative",
  },
  advancedSearchButton: {
    left: 4,
    width: "calc(100% - 8px)",
  },
};

const AssetsWrap = ({ height, loading, search, setSearch, children, skeletonCheckbox, fields, sx: sxProp, hideFilterChips }) => {
  const [value, setValue] = useState(search);
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
  const { user } = useAuth();
  const { settings } = user.company;
  const params = useQueryParams();
  const isReceivingWizardDisabled = params.get("disable_receiving_wizard") === "true";
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  useEffect(() => {
    setValue(search);
  }, [search]);

  const handleSubmit = event => {
    event.preventDefault();
    setSearch(value);
  };

  const handleAdvancedSearchSubmit = value => {
    setValue(value);
    setSearch(value);
    setShowAdvancedSearch(false);
  };

  return (
    <Card sx={{ ...styles.card, ...sxProp }} style={{ height }}>
      <CardContent sx={sxProp ? { display: "flex", flexDirection: "column", flex: 1, minHeight: 0, "&:last-child": { pb: 2 } } : undefined}>
        <Grid container spacing={1} sx={sxProp ? { flex: 1, minHeight: 0, display: "flex", flexDirection: "column" } : undefined}>
          {!hideFilterChips && <ActiveFilterChips sx={{ mb: 0.5 }} />}
          <Grid sx={styles.searchContainer} size={12}>
            {settings.receiving_wizard ? (
              <SearchScanner
                value={value}
                search={search}
                setSearch={setSearch}
                showNAButton={false}
                onAdvancedSearchClick={() => setShowAdvancedSearch(true)}
              />
            ) : (
              <form onSubmit={handleSubmit}>
                <FormControl fullWidth>
                  <SearchInput
                    value={value}
                    onChange={setValue}
                    setSearch={setSearch}
                    onAdvancedSearchClick={() => setShowAdvancedSearch(true)}
                  />
                </FormControl>
              </form>
            )}
            <Box position="relative">
              {showAdvancedSearch && (
                <AdvancedSearch
                  initialValue={value}
                  onSearch={handleAdvancedSearchSubmit}
                  onCancel={() => setShowAdvancedSearch(false)}
                  fields={fields}
                />
              )}
            </Box>
          </Grid>
          {isMobile && isReceivingWizardDisabled && (
            <Grid size={12}>
              <Box display="flex" justifyContent="center" mt={1} mb={1}>
                <Chip
                  label="Receiving Assistant Disabled"
                  size="small"
                  color="warning"
                  variant="outlined"
                />
              </Box>
            </Grid>
          )}
          <Grid size={12} sx={sxProp ? { display: "flex", flexDirection: "column", flex: 1, minHeight: 0 } : undefined}>
            {loading
              ? [...Array(5)].map((_, index) => (
                  <AssetItemSkeleton key={index} checkbox={skeletonCheckbox} />
                ))
              : children}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default AssetsWrap;
